import React from 'react';

function Shimmer({ column }) {
    return (
        <>
            <tbody>
                {[...Array(10)].map((index = 0) => (
                    <tr className="animate-pulse" key={index}>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[150px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[125px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[125px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[125px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[125px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[125px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[125px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[125px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[125px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[125px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[125px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[125px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[125px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                        <td className="text-sm font-light text-[#13365C] p-2.5 min-w-[125px]">
                            <div className="h-7 bg-slate-200 rounded" />
                        </td>
                    </tr>
                ))}
            </tbody>
        </>
    );
}

export default Shimmer;